import { createApp } from 'vue'
import naive from 'naive-ui'
import { pinia } from './pinia'
import router from './router'
import App from './App.vue'
// import 'material-icons/iconfont/material-icons.css'
import './css/main.css'

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(naive)
app.mount('#app')
